import { Component, Inject, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type DeleteDialogDataWithTemplate = {
  header: string;
  formGroup?: FormGroup;
  deleteText: string;
  secondaryText: string;
  noText: string;
  template: TemplateRef<any>;
  bottomSection: TemplateRef<any>;
  onDelete: () => Promise<boolean>; //a function that is called when clicking okay. If returns true, closes modal
  onSecondary: () => void;
};

@Component({
  selector: 'dialog-delete',
  templateUrl: 'delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
})
export class DeleteDialogComponent {
  public deleteDialogAction = DeleteDialogAction;
  public textMatcherValue = '';

  constructor(
    public dialogRef: MatDialogRef<DeleteDialogComponent, DeleteDialogAction>,
    @Inject(MAT_DIALOG_DATA)
    public data: DeleteDialogDataWithTemplate
  ) {}

  clickClose = async (action: DeleteDialogAction): Promise<DeleteDialogAction> => {
    switch (action) {
      case DeleteDialogAction.Delete:
        if (this.data.formGroup?.invalid) {
          this.data.formGroup.markAllAsTouched();
          return null;
        }
        const isSuccess = this.data.onDelete ? await this.data.onDelete() : true;

        if (isSuccess) {
          this.dialogRef.close(DeleteDialogAction.Delete);
          return DeleteDialogAction.Delete;
        }
        return null; //onDelete promise failed or returned false

      case DeleteDialogAction.Secondary:
        if (this.data.onSecondary) {
          await this.data.onSecondary();
        }
        this.dialogRef.close(DeleteDialogAction.Secondary);
        return DeleteDialogAction.Secondary;
      default:
        this.dialogRef.close(action);
        return action;
    }
  };

  isDeleteButtonDisabled() {
    return this.textMatcherValue != 'DELETE';
  }
}

export enum DeleteDialogAction {
  Delete,
  Secondary,
  Cancel,
}
